import { render } from "./RejectedNotificationTable.vue?vue&type=template&id=f6462e94&ts=true"
import script from "./RejectedNotificationTable.vue?vue&type=script&lang=ts"
export * from "./RejectedNotificationTable.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__